module.exports = __webpack_public_path__ + "static/media/colisactiv.a26586b8.png";